module.exports = "<div class=\"totop\" (click)=\"toTop()\" id=\"totop-btn\">\n    <img src=\"../../../assets/icon/top.svg\" />\n    <span>TOP</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/share/to-top/to-top.component.html
// module id = ../../../../../src/app/share/to-top/to-top.component.html
// module chunks = main